function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgOnlinePharmacy = function SvgOnlinePharmacy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M15.253 5.64h3.325v14.935H6V5.64h3.316"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M15.228 4H9.346v3.19h5.882zM8.33 10.74h7.915M8.33 13.882h3.936"
  }));
};
export default SvgOnlinePharmacy;